// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3016":"f7b1ad08","3671":"a83f4675","3912":"a83f4675","4522":"f7b1ad08","5680":"f7b1ad08","6572":"a83f4675","7399":"95572145"}[chunkId] + ".chunk.css";
};